export default __webpack_public_path__ + "static/media/lamborghini.0da76cf0.png";